<template>
  <div class="c-main-flex-1">
    <div class="o-layout">
      <div class="o-layout__item u-1-of-1">
        <div class="o-layout">
          <div class="o-layout__item">
            <div class="c-input--extra-info">
              <span v-html="$t('event.login.' + type + '.description')"></span>
              <span v-html="$t('event.login.general.description')"></span>
            </div>
          </div>

          <div class="o-layout__item">
            <div class="c-input--extra-info">
              <a :href="url" target="_blank">{{ url }}</a>
            </div>
          </div>
          <div class="o-layout__item">
            <a class="c-button c-button--primary c-button--large" :href="internalUrl" target="_blank">
              {{ $t('event.login.openPage') }}
            </a>
          </div>
        </div>
      </div>
      <div class="o-layout__item u-1-of-1 u-margin-bottom-large">
        <canvas id="code" class="code" ref="code" width="250" height="250"></canvas>
      </div>

      <div class="o-layout__item u-1-of-1" v-if="type !== 'display'">
        <strong>Access Token:</strong>
        <dl>
          <dt>
            Created:
          </dt>
          <dd>
            {{ accessTokenCreated() }}
          </dd>
          <dt>
            Expires:
          </dt>
          <dd>
            {{ accessTokenExpires() }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import QRious from 'qrious'
import config from "@/config";

import moment from 'moment'

export default {
  name: "EventLogin",
  data: () => {
    return {
      url: '',
      internalUrl: '',
      accessToken: null,
    }
  },
  computed: {
    type() {
      return this.$route.params.type
    },
    host: function() {
      return this.$store.state.environment.baseUrl
    },
  },
  created: function() {
    if (this.type !== 'display') {
      this.$http.get(config.root + '/events/' + this.$route.params.eventId + '/get-access-token',
        { params: { role: this.type }}).then((response) => {
        this.accessToken = response.data
        this.setUrl()
      })
    }
    else {
      this.setUrl()
    }
  },
  watch: {
    host: {
      immediate: true,
      handler: function() {
        this.setUrl()
      },
    },
    url: {
      handler: function() {
        this.$nextTick(() => {
          new QRious({
            size: 250,
            element: this.$refs.code,
            value: this.url,
          })
        })
      },
      immediate: true
    }
  },
  methods: {
    setUrl: function() {
      console.log('Setting URL for event login')
      if (this.type === 'display') {
        this.url = this.host + '/display.html#/event/' + this.$route.params.eventId
        this.internalUrl = this.url
      }
      else {
        if (this.accessToken) {
          this.url = this.host + '/#/login?userId=' + this.accessToken.userId + '&token=' + this.accessToken.id
        }
        this.internalUrl = '/#/' + this.type + '/' + this.$route.params.eventId
      }
    },
    accessTokenCreated: function() {
      return moment(this.accessToken.created).format('YYYY-MM-DD HH:mm:ss')
    },
    accessTokenExpires: function() {
      return moment(this.accessToken.created).add(this.accessToken.ttl, 's').format('YYYY-MM-DD HH:mm:ss')
    },
  },
}
</script>

<style scoped>
.code {
  margin: 50px auto auto;
  display: block;
}
</style>
